module.exports = __webpack_public_path__ + "media/images/black_history_month/jackie-summers-51f1e10d8fc7540fdd17967d05218c43.png";